import { render } from "./UserIdentification.vue?vue&type=template&id=006c32d3&scoped=true"
import script from "./UserIdentification.vue?vue&type=script&lang=js"
export * from "./UserIdentification.vue?vue&type=script&lang=js"

import "./UserIdentification.vue?vue&type=style&index=0&id=006c32d3&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006c32d3"]])

export default __exports__